(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_fccb40e"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__rfImageGalleryReady) return;
  window.__rfImageGalleryReady = true;

  const imagesFor = (gallery) => Array.from(gallery.querySelectorAll('[data-gallery-open]'));

  const showImage = (gallery, viewer, index) => {
    const images = imagesFor(gallery);
    if (!images.length) return;
    const image = images[(index + images.length) % images.length];
    viewer.dataset.currentIndex = String((index + images.length) % images.length);
    const display = viewer.querySelector('[data-gallery-current]');
    display.src = image.dataset.gallerySrc;
    display.alt = image.dataset.galleryAlt || '';
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-gallery-open]');
    if (opener) {
      const gallery = opener.closest('[data-image-gallery]');
      const viewer = gallery.querySelector('[data-gallery-viewer]');
      showImage(gallery, viewer, imagesFor(gallery).indexOf(opener));
      viewer.showModal();
      return;
    }

    const control = event.target.closest('[data-gallery-control]');
    if (control) {
      const viewer = control.closest('[data-gallery-viewer]');
      const gallery = control.closest('[data-image-gallery]');
      if (control.dataset.galleryControl === 'close') {
        viewer.close();
      } else {
        const direction = control.dataset.galleryControl === 'next' ? 1 : -1;
        showImage(gallery, viewer, Number(viewer.dataset.currentIndex) + direction);
      }
      return;
    }

    if (event.target.matches('[data-gallery-viewer]')) event.target.close();
  });

  document.addEventListener('keydown', (event) => {
    const viewer = event.target.closest?.('[data-gallery-viewer]');
    if (!viewer || !viewer.open) return;
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault();
    const gallery = viewer.closest('[data-image-gallery]');
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    showImage(gallery, viewer, Number(viewer.dataset.currentIndex) + direction);
  });

  let touchStartX = 0;
  document.addEventListener('touchstart', (event) => {
    if (event.target.closest('[data-gallery-viewer]')) touchStartX = event.changedTouches[0].clientX;
  }, { passive: true });

  document.addEventListener('touchend', (event) => {
    const viewer = event.target.closest('[data-gallery-viewer]');
    if (!viewer || !viewer.open) return;
    const distance = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(distance) < 45) return;
    const gallery = viewer.closest('[data-image-gallery]');
    showImage(gallery, viewer, Number(viewer.dataset.currentIndex) + (distance < 0 ? 1 : -1));
  }, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

})();
